import React, {useEffect, useState} from "react";
import {gsap} from "gsap";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Container, Row, Col} from "react-bootstrap";

// Global Styles
import GlobalStyle from "./styles/globalStyle";
import LiveEvent from "./components/LiveEvent";
import Menu from "./components/Menu";
import MainContent from "./components/MainContent";
import Header from "./components/Header";
import {useLocation} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "./api/network/apiEndPoints";
import {ApiParam} from "./api/network/apiParams";
import {fetchHome} from "./api/redux/home";

// Register GSAP Plugins
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

function App() {
    const [isOpen, setOpen] = useState(false);
    const location = useLocation();
    const pathname = location.pathname;
    const [path, setPath] = useState("");


    const dispatch = useDispatch();

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.SECTIONS;

        let api_params = {
            [ApiParam.TYPE]: "slug",
            [ApiParam.VALUE]: "home",
            [ApiParam.GET_SECTION]: "yes",
            [ApiParam.IMAGE]: "yes",
            [ApiParam.POST]: "yes",
        };

        dispatch(fetchHome([api_url, api_params]));
    }, []);

    const getData = useSelector((state) => state.home);
    const liveEvent = getData?.posts?.data?.sections?.find(
        (f) => f?.section_data?.slug === "live-event"
    )?.section_data;

    const handleMenuOpen = () => {
        setOpen(!isOpen)
    }

    useEffect(() => {
        const pathMap = {
            "/architecture": "Architecture",
        };
        setPath(pathMap[pathname] || "");
    }, [pathname]);

    return (
        <>
            <GlobalStyle/>
            <ToastContainer
                position="top-right"
                autoClose={4000}
                closeOnClick
                hideProgressBar={true}
            />
            {liveEvent?.subtitle && <LiveEvent/>}
            <header>
                <Container>
                    <Row>
                        <Col md={{offset: 2, md: 10, sm: 12}}>
                            <Header isOpen={isOpen} handleMenuOpen={handleMenuOpen}/>
                        </Col>
                    </Row>
                </Container>
            </header>
            <Container>
                <Row>
                    <Col md={2}>
                        <Menu path={path} setOpen={setOpen} handleMenuOpen={handleMenuOpen} isOpen={isOpen}/>
                    </Col>
                    <Col md={10}>
                        <MainContent handleMenuOpen={handleMenuOpen}/>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default App;
